import { render, staticRenderFns } from "./CertificationInventoryList.vue?vue&type=template&id=77ffb4bc&scoped=true"
import script from "./CertificationInventoryList.vue?vue&type=script&lang=js"
export * from "./CertificationInventoryList.vue?vue&type=script&lang=js"
import style0 from "./CertificationInventoryList.vue?vue&type=style&index=0&id=77ffb4bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ffb4bc",
  null
  
)

export default component.exports